import {Component, Input, OnDestroy, OnInit, input} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {Chart} from 'angular-highcharts';
// import {CountriesData} from 'countries-map';
import {ChartService} from '../../chart.service';
import * as fromApp from '../../../store/app.reducers';
import * as fromProfile from '../../store/profile.reducers';
import * as ProfileActions from '../../store/profile.actions';
import * as PostActions from '../../post/store/post.actions';
import {Profile} from '../../profile.model';
import {SettingsService} from '../../../core/settings.service';
import * as DemoActions from '../../../demo/store/demo.actions';
import {HelperService} from '../../../share/helper.service';
import {ToastrService} from 'ngx-toastr';


@Component({
    selector: 'app-followers-location',
    templateUrl: './followers-location.component.html',
    styleUrls: ['./followers-location.component.scss'],
    standalone: false
})
export class FollowersLocationComponent implements OnInit, OnDestroy {

  readonly type = input<number>(undefined);
  readonly auditType = input<'profile' | 'demo'>(undefined);
  @Input() id: number;
  code: string;
  typeFollowers: number;
  initData: boolean;
  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  chartsLocation: Chart[];
  audit: Profile;
  mapsApiKey: string;
  // public mapData: CountriesData = {
  public mapData: any = {
    'ES': { 'value': 416 },
    'GB': { 'value': 94 },
    'FR': { 'value': 255 }
  };

  sectionName = {
    city: '',
    country: ''
  };

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private notifierService: ToastrService,
    private settingsService: SettingsService,
    private helperService: HelperService
  ) { }

  getAuditType(): 'profile' | 'demo' {
    const auditType = this.auditType();
    if (auditType === undefined) {
      return 'profile';
    }
    return auditType;
  }

  getAuditActions() {
    const auditType = this.auditType();
    if (auditType === undefined || auditType === 'profile') {
      return ProfileActions;
    } else if (auditType === 'demo') {
      return DemoActions;
    }
  }

  ngOnInit() {
    this.sectionName.city = this.helperService.generateRandomString(10);
    this.sectionName.country = this.helperService.generateRandomString(10);

    this.mapsApiKey = this.settingsService.getSetting('mapsApiKey');
    this.initData = false;
    this.profileState = this.store.select(this.getAuditType());
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;
      }
    );
    this.profileSubscription = this.store.select(this.getAuditType()).subscribe(
      (state: fromProfile.State) => {
        this.audit = state.audit;

        const auditType = this.auditType();
        if (state.audit !== null && state.audit.status !== 0 && !this.initData && auditType === 'profile') {
          this.initData = true;
          if (this.id !== undefined) {
            if (+this.type() === 1) {
              this.typeFollowers = 1;
            } else if (+this.type() === 2) {
              this.typeFollowers = 2;
            }
            this.setTypeFollowers(this.typeFollowers);
          }
        }

        if (state.audienceLocation !== null && (state.chartReload === this.getAuditActions().SET_AUDIENCE_LOCATION || auditType === 'demo')) {
          this.chartsLocation = [];
          this.chartsLocation.push(
            ChartService.getLocationCityAudienceChart(state.audienceLocation.city_rank),
            ChartService.getLocationCountryAudienceChart(state.audienceLocation.country_rank)
          );
          this.mapData = ChartService.getLocationCountryForMap(state.audienceLocation.country_rank);
        }

      }
    );
  }

  setTypeFollowers(type: number) {
    if (this.id !== undefined && this.audit !== null && this.audit.status !== 0) {
      if (+this.type() === 1) {
        this.typeFollowers = type;
        this.store.dispatch(
          new ProfileActions.GetAudienceLocation({
            id: this.id,
            type: type,
            params: {
              code: this.code
            }
          })
        );
      } else if (+this.type() === 2) {
        this.typeFollowers = type;
        this.store.dispatch(
          new PostActions.GetAudienceLocation({
            id: this.id,
            type: type
          })
        );
      }
    } else if (this.audit !== null && this.audit.status === 0) {
      this.notifierService.warning('No access in trial account');
    } else {
      this.notifierService.warning('No access in demo audit');
    }
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }

}
